import React from 'react';

const Spinner = ({ label = 'Loading...', small = false, className = '' }) => {
  const sizeClass = small ? 'spinner-border-sm' : '';

  return (
    <div className={`d-inline-flex align-items-center gap-2 ${className}`.trim()}>
      <div className={`spinner-border text-primary ${sizeClass}`.trim()} role="status" aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </div>
  );
};

export default Spinner;
